import { ng } from '@uirouter/angularjs/lib/angular';
import angular = require('angular');
import { IStoreTableModel, IStoreTableModelWithOldName } from '../../../models';
import { ShopService } from '../../../shop.service';

class AddOrEditTable implements ng.IController {
    public static $inject = [
        'shopService'
    ];
    public modalInstance: ng.ui.bootstrap.IModalInstanceService = this as any;
    public waiting: boolean;

    public model = {
        dialogTitle: '',
        tableID: null,
        tableName: '',
        tableDescription: '',
        isEditMode: false,
        oldName: '',
        tableNameIsAlreadyExist: false
    };

    public resolve: {
        shopID: number;
        isEditMode: boolean;
        tableID: number;
        tableName: '',
        tableDescription: '',
        existsTables: IStoreTableModel[]
    };

    public requiredDateError = false;

    constructor(
        private shopService: ShopService
    ) {
    }

    public async $onInit() {
        this.model.isEditMode = this.resolve.isEditMode;

        this.model.tableID = this.resolve.tableID;
        this.model.tableName = this.resolve.tableName;
        this.model.tableDescription = this.resolve.tableDescription;
        this.model.oldName = angular.copy(this.resolve.tableName);
    }

    public async validateTableOnExist() {

        if (!this.model.tableName) {
            return;
        }

        this.model.tableNameIsAlreadyExist = false;

        if (!this.model.isEditMode) {
            if (this.existTableInLocalTables(this.model.tableName) || await this.existTableInRemoteTables(this.model.tableName)) {
                this.model.tableNameIsAlreadyExist = true;
            }
            return;
        }

        if (this.model.tableName !== this.model.oldName) {
            if (this.existTableInLocalTables(this.model.tableName) || await this.existTableInRemoteTables(this.model.tableName)) {
                this.model.tableNameIsAlreadyExist = true;
            }
        }
    }

    public save() {
        const model: IStoreTableModelWithOldName = {
            ID: this.model.tableID,
            Name: this.model.tableName,
            Description: this.model.tableDescription,
            OldName: this.model.oldName
        };

        this.modalInstance.close({$value: model});
    }

    public close() {
        this.modalInstance.close();
    }

    private existTableInLocalTables(tableName: string) {
        return this.resolve.existsTables.some((table) => table.Name === tableName);
    }

    private async existTableInRemoteTables(tableName: string) {
        this.waiting = true;
        let exist: boolean = false;
        try {
            exist = await this.shopService.isTableExist(this.resolve.shopID, tableName);
        } catch (error) {
            console.log(error);
        } finally {
            this.waiting = false;
        }
        return exist;
    }

}

angular.module('naut').component('addOrEditTable', {
    template: require('./add-or-edit-table.component.html'),
    controller: AddOrEditTable,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/places/components/shop-tables/add-or-edit-table/add-or-edit-table.component.ts